import * as React from "react";
import { AuthLayout } from "../layout";
import { AuthLoginForm } from "./login.form";
import { AuthHeading, AuthSubheading } from "./login.form.c";
import { inject, observer } from "mobx-react";
import { MobxComponent } from "../../../../mobx/components/index";

interface Props { }
interface State {
	loading: boolean;
}

@inject("store") @observer
export class AuthLogin extends MobxComponent<Props, State> {

	constructor(props: Props) {
		super(props);
		this.state = {
			loading: false,
		};
	}

	load = (loading: boolean) => {
		this.setState({ loading });
	}

	render() {
		return (
			<AuthLayout loading={this.state.loading}>
				<AuthHeading>Welcome back</AuthHeading>
				<AuthSubheading>Sign in to your account to continue.</AuthSubheading>
				<AuthLoginForm load={this.load} loading={this.state.loading} />
			</AuthLayout>
		);
	}

}
